import { render, staticRenderFns } from "./UserEditAccount.vue?vue&type=template&id=729e496e&"
import script from "./UserEditAccount.vue?vue&type=script&lang=js&"
export * from "./UserEditAccount.vue?vue&type=script&lang=js&"
import style0 from "./UserEditAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports